import IntegrationOverview from '../../../../../components/integration-overview/IntegrationOverview';
import AtosaLogo from '../../../../../assets/atosa.png';
import { useFirmContext } from '../../../../../providers/FirmProvider';
import { Entity } from '../../../../../types/entity';
import TaxpayerSelect from './TaxpayerSelect';
import { calcRelativeTime, formatDateTime } from '../../../../../utilities/formatting';
import { Link } from 'react-router-dom';
import LinkedTaxpayer from './LinkedTaxpayer';

type EntityAtosaIntegrationProps = {
    entity: Entity;
};
function EntityAtosaIntegration({ entity }: EntityAtosaIntegrationProps): JSX.Element {
    const { allowedIntegrations, integrations } = useFirmContext();
    const allowedAtosa = allowedIntegrations?.includes('atosa');
    const atosa = entity.integrations.atosa;

    const content = !atosa
        ? []
        : [
              { label: 'Created By', value: `${atosa.createdBy?.firstName} ${atosa.createdBy?.lastName}` },
              { label: 'Created', value: calcRelativeTime(atosa.createdAt), tooltip: formatDateTime(atosa.createdAt) },
          ];

    return (
        <IntegrationOverview
            title="Atosa"
            description="Link a taxpayer to an entity."
            active={Boolean(atosa)}
            logo={AtosaLogo}
            comingSoon={!allowedAtosa}
            supportLink="#"
            sideContent={content}
        >
            <div className="mt-2">
                {!integrations.atosa ? (
                    <p className="text-sm text-gray-700">
                        Please setup your Atosa credentials on the{' '}
                        <Link to={'../../settings?tab=integrations&focusedIntegration=atosa'} className="text-indigo-600 underline">
                            firm settings page
                        </Link>
                        .
                    </p>
                ) : (
                    <div>{atosa ? <LinkedTaxpayer entity={entity} /> : <TaxpayerSelect entityId={entity.id} />}</div>
                )}
            </div>
        </IntegrationOverview>
    );
}

export default EntityAtosaIntegration;
